import React from 'react';

import PillSwitcher from 'components/lib/PillSwitcher';
import { useSalesBattlecardContext } from 'components/SalesBattlecard/SalesBattlecardContext';
import { useCommunityViewContext } from 'components/View/CommunityViewContext';
import useDataQuarterSelection from 'hooks/useDataQuarterSelection';
import { CommunityType } from 'types/communities';

type Props = {
  selectedCommunityId: number;
  onCommunityChange: (communityId: number) => void;
  filteredCompetitorIds?: number[];
};

export const CommunitySwitcher = ({ selectedCommunityId, onCommunityChange, filteredCompetitorIds }: Props) => {
  const { community, competitors, viewFilters } = useCommunityViewContext();
  const { selectedCompetitorId: battlecardCompetitorId } = useSalesBattlecardContext();
  const { selection, snapshotsByCommunity, snapshotUuids } = useDataQuarterSelection();

  const allowedIds =
    battlecardCompetitorId !== null
      ? [battlecardCompetitorId]
      : filteredCompetitorIds && filteredCompetitorIds.length > 0
        ? filteredCompetitorIds
        : viewFilters?.competitors;
  const baseCompetitors = allowedIds?.length
    ? (competitors || []).filter((c) => allowedIds.includes(c.id))
    : competitors || [];

  const filteredCompetitors =
    selection?.includePriorCompetitors === false && selection?.selectedQuarterSlug && snapshotUuids !== null
      ? baseCompetitors.filter((competitor) => Boolean(snapshotsByCommunity?.[competitor.id]))
      : baseCompetitors;

  const allCommunities = [community, ...filteredCompetitors].filter((c): c is CommunityType => c != null);

  const items = allCommunities.map((item, idx) => ({
    key: item.id,
    label: `${item.comunity_name}${idx === 0 ? ' (Me)' : ''}`,
  }));

  return (
    <PillSwitcher
      items={items}
      activeKey={selectedCommunityId}
      onChange={onCommunityChange}
      getItemTestId={(id) => `widget-community-switcher-${id}`}
    />
  );
};

export default CommunitySwitcher;
